<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
    <meta name="theme-color" content="#101714" />
    <meta name="description" content="Lah Lane is a fictional tropical road-sense game. Spot the hazard before the blur driver strikes." />
    <meta property="og:title" content="Lah Lane — Spot the hazard before it happens" />
    <meta property="og:description" content="A fast road-sense quiz set in a fictional tropical city. No real roads. No real drivers. Just sharp eyes." />
    <title>Lah Lane — Road Sense Quiz</title>
    <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
  </head>
  <body>
    <div id="app"></div>
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
